import { DateRange } from '@rossum/ui/x-date-pickers-pro';
import { getCustomFixedDateTime } from './shortcuts';
import { DateOperator } from './types';

export const shouldBeEndOfDay = (operatorValue: DateOperator) =>
  operatorValue === 'onOrBefore' || operatorValue === 'after';

// see test file for details
export const handleNonRangedDateChange = ({
  selectedDates,
  selectionState,
  dateRange,
  operatorValue,
}: {
  dateRange: DateRange<Date>;
  selectionState?: 'partial' | 'finish' | 'shallow';
  selectedDates: [Date | null, Date | null];
  operatorValue: DateOperator;
}) => {
  const [from, to] = dateRange;

  const targetDate =
    selectionState === 'finish'
      ? selectedDates[0] === from
        ? to
        : from
      : (from ?? to);

  // targetDate should never be null here
  return targetDate
    ? getCustomFixedDateTime(targetDate, shouldBeEndOfDay(operatorValue))
    : null;
};
